{
  "version": 1,
  "asset_id": "d05925e5-e13c-42c7-a93c-74db074758a9",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/d05925e5-e13c-42c7-a93c-74db074758a9/ShareTheLove.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/d05925e5-e13c-42c7-a93c-74db074758a9/ShareTheLove.png",
  "original_filename": "ShareTheLove.png",
  "size": 602357,
  "content_type": "image/png",
  "created_at": "2026-08-18T18:27:09Z"
}
